import { Navigate, Outlet } from 'react-router-dom';
import {
  InvoicingFeatureName,
  ROUTES,
  useInvoicingConfig,
} from '@jobcost-monorepo/utils';
import { Button, SplashScreen } from '@jobcost-monorepo/ui';
import { useTranslation } from '@jobcost-monorepo/i18n';

interface InvoicingFeatureRouteProps {
  feature: InvoicingFeatureName;
}

/**
 * Protegge le pagine legate al provider di fatturazione (Autofatture e
 * Credenziali Gestify con Previxio): se la funzione è spenta si torna al
 * timesheet. Se la configurazione non si legge la pagina NON si apre (stessa
 * scelta prudente del bottone Fattura): si mostra l'errore con "Riprova".
 */
const InvoicingFeatureRoute = ({ feature }: InvoicingFeatureRouteProps) => {
  const { t } = useTranslation('commons');
  const { config, loading, error, reload } = useInvoicingConfig();

  if (loading) return <SplashScreen />;
  if (error || !config) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 p-8">
        <span className="text-md font-medium text-gray-700 dark:text-white">
          {t('invoicingConfig.error')}
        </span>
        <Button type="button" onClick={reload}>
          {t('invoicingConfig.retry')}
        </Button>
      </div>
    );
  }
  if (!config.features[feature]) {
    return <Navigate to={`/${ROUTES.TIMESHEET_SINGLE}`} replace />;
  }
  return <Outlet />;
};

export default InvoicingFeatureRoute;
